@if (data.html && data.html !=='') {
  <form class="m-3" [formGroup]="form" #template>
    @for (field of formFields; track field) {
      @if (field.type === 'text') {
        {{ field.value }}
      } @else {
        <input class="w-300px efx-input m-2" type="text" [formControlName]="field.name" placeholder="{{field.placeholder}}">
      }
    }
  </form>
}